import Repository from '../../base/Repository';

export default class BilletDownloadRemittanceRepository extends Repository {
  public async download(
    idsCustomer: string[],
    companyGroupId: number,
  ): Promise<void> {
    await this.datasource.send(
      `company-groups/${companyGroupId}/remittances/accounts-receivable/bank-slips/download`,
      { ids_customer: idsCustomer },
    );
  }
}
